import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalFooter } from 'reactstrap';
import { useDispatch } from 'react-redux';
import * as commonActions from '@common/common.action';
import { arquivamentoTipoEmum } from '../../../../arquivamento.utils';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function Remover(props) {
  const intl = useIntl()
  const dispatch = useDispatch();
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const [modalAberto, setModalAberto] = useState(false);

  useEffect(() => {
    setModalAberto(props.showModalRemover);
    dispatch(commonActions.showModal(props.showModalRemover));
  }, [props.showModalRemover]);

  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  return (
    <Modal
      size={'ie'}
      isOpen={modalAberto}
      toggle={toggle}
      backdrop={backdrop}
      keyboard={keyboard}
      centered
    >
      <ModalHeader toggle={props.toggle}>
        <div>{`${intl.formatMessage({id: 'general.materialArchiving.remove'})} ${props.itemSelecionado.numeroMaterial}`}</div>
      </ModalHeader>

      <div style={{ marginLeft: '15px', marginTop: '20px' }}>
        {`${intl.formatMessage({id: 'general.materialArchiving.removeArchive'})} ${props.itemSelecionado.numeroMaterial}?`}
      </div>

      <ModalFooter>
        <Button color='secondary' onClick={toggle}>
          <IntlMessage id="general.materialArchiving.close" />
        </Button>
        <Button color='primary' onClick={() => props.removerItem()}>
        <IntlMessage id="general.materialArchiving.confirm" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default Remover;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/modais/Remover/index.js